// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"268":"Home","362":"Dashboard"}[chunkId] || chunkId) + "." + {"60":"1462bab1","174":"88f8bddb","268":"6b0b4656","362":"45699cae","393":"57192f99"}[chunkId] + ".js";
};